import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import CustomerHeader from '../../components/ui/CustomerHeader';
import Footer from '../../components/ui/Footer';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';

const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <CustomerHeader onCartClick={() => navigate('/shopping-cart')} />

      <main className="pt-20">
        {/* Our Story */}
        <section id="about" className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              {/* Image */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true, margin: '-80px' }}
                className="order-1"
              >
                <div className="relative overflow-hidden rounded-2xl shadow-xl ring-1 ring-border">
                  <Image
                    src="/about-us.jpg"
                    alt="The maker behind BounderLaster with her handmade soaps"
                    className="w-full h-full object-cover"
                  />
                </div>
              </motion.div>

              {/* Copy */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true, margin: '-80px' }}
                className="order-2"
              >
                <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">
                  BounderLaster &middot; Soap &amp; Home
                </p>
                <h1 className="text-4xl sm:text-5xl font-bold text-foreground mb-6">
                  Our Story
                </h1>

                {/*
                  PLACEHOLDER COPY — soap-focused stand-in until the owner sends
                  the real "Our Story" text from her previous Shopify site.
                  Replace the two paragraphs below verbatim when received.
                */}
                <div className="space-y-5 text-lg leading-relaxed text-foreground/80">
                  <p>
                    BounderLaster began with a simple belief — that the soap you reach
                    for every day should be as honest as it is kind to your skin. Every
                    bar is handmade in small batches, poured and cut by hand, using
                    skin-loving natural ingredients instead of harsh detergents and fillers.
                  </p>
                  <p>
                    From our Oatmeal &amp; Honey and Peppermint Clay bars to Activated
                    Charcoal and African Black, each recipe is crafted to cleanse gently
                    and leave skin feeling soft, balanced, and cared for. Soap and home
                    essentials, made with intention — and made to be loved.
                  </p>
                </div>

                <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium text-foreground/70">
                  <span className="inline-flex items-center gap-2">
                    <Icon name="Leaf" size={18} className="text-primary" />
                    Natural ingredients
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <Icon name="Hand" size={18} className="text-primary" />
                    Handmade in small batches
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <Icon name="Heart" size={18} className="text-primary" />
                    Kind to your skin
                  </span>
                </div>

                <button
                  onClick={() => navigate('/product-catalog')}
                  className="mt-10 inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity"
                >
                  Shop our soaps
                  <Icon name="ArrowRight" size={18} />
                </button>
              </motion.div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
